import {
    PENDING_AGE_TONE_CLASS,
    pendingAgeDays,
    pendingAgeLabel,
    pendingAgeTone,
} from '@/lib/einvoice-pending-age'
import { twJoin } from '@/lib/utils'

/** "Giao 5 ngày trước", grey, amber or red by how long the order has waited. */
export function PendingAgeLabel({ deliveredAt }: { deliveredAt: string }) {
    const days = pendingAgeDays(deliveredAt)
    const tone = pendingAgeTone(days)
    return (
        <span
            data-tone={tone}
            className={twJoin('text-xs', PENDING_AGE_TONE_CLASS[tone])}
        >
            {pendingAgeLabel(days)}
        </span>
    )
}
